module.exports = __webpack_public_path__ + "static/media/balloon.cc5927da.svg";